<!-- Translucent overlay element -->
<div class="w-full h-full flex flex-col">
  <div class="h-fit sm:visible lg:hidden mt-2 pt-2 w-full">
    <img
      src="../../../../../assets/svg/luminous_connectx.svg"
      alt="Overlay"
      class="pl-[10%] h-[2.5rem] mt-2"
    />
  </div>
  <div
    class="flex flex-col sm:flex-grow sm:pl-1.5 lg:pl-unset lg:flex-grow-0 font-sans text-base font-normal lg:h-full lg:items-center text-blue-gray-700 sidebar sm:w-full sm:h-full"
    (click)="stopPropogation($event)"
  >
    <div
      class="h-full w-full lg:flex lg:items-center flex-col lg:pt-36 sm:pt-[8%]"
    >
      @for (item of menuItems(); track $index) {
        @if (item.enable) {
          @if (item.position === "Top") {
            @if (item.route === "dashboard/customer-dashboard") {
              <div
                role="button"
                class="group sm:w-full relative flex items-center w-full py-4 pl-2 leading-tight transition-all md outline-none text-start hover:bg-gray-800 hover:rounded-r-2xl active:bg-blue-gray-50 active:bg-opacity-80 active:text-blue-gray-900 menu-item cursor-default"
                routerLinkActive="selected-menu-item"
                #rla="routerLinkActive"
                (click)="
                  !item.disableOption && isPlantExist(plantList)
                    ? null
                    : routeToCustomerDashboard(item.route)
                "
                [ngClass]="{ tooltip: true, 'selected-menu-item': isActive }"
              >
                <div class="grid mr-4">
                  @if (!item.disableOption && isPlantExist(plantList)) {
                    <div
                      class="flex flex-col justify-start items-start flex-grow plant-menu-dropdown w-[230px] text-center text-white text-xs rounded-tr-lg rounded-br-lg gap-2 opacity-1 invisible dark:bg-dimGrey z-20 pr-4 py-4"
                    >
                      <span
                        class="text-sm font-bold px-2 text-dark-accent-secondary pl-7"
                        >Plant List</span
                      >
                      <div
                        class="w-full flex flex-row justify-center items-center space-x-4"
                      >
                        <div
                          class="dark:bg-none px-4 py-[4px] dark:text-white rounded-xl border-solid border-[0.5px] border-gray-300 flex items-center space-x-2 cursor-pointer"
                          [ngClass]="{
                            'bg-dark-accent-secondary': isPrimaryPlant === true
                          }"
                          (click)="togglePrimaryPlant()"
                        >
                          <span> {{ "Primary" }}</span>
                        </div>
                        <div
                          class="dark:bg-none px-4 py-[3px] dark:text-white rounded-xl border-solid border-[0.5px] border-gray-300 flex items-center space-x-2 cursor-pointer"
                          [ngClass]="{
                            'bg-dark-accent-secondary': isPrimaryPlant !== true
                          }"
                          (click)="togglePrimaryPlant()"
                        >
                          <span> {{ "Secondary" }}</span>
                        </div>
                      </div>
                      <div>
                        <div
                          class="fixed w-[230px] bg text-center text-white text-xs rounded-tr-lg rounded-br-lg gap-2 opacity-1 dark:bg-dimGrey pr-4 pb-4"
                        >
                          @if (isPrimaryPlant) {
                            <div
                              class="max-h-64 overflow-scroll w-full max-auto-scroll"
                            >
                              @for (
                                plant of plantList?.primaryPlant;
                                track $index
                              ) {
                                <a (click)="navigateToDashboard(plant)">
                                  <div
                                    (click)="addNewItem()"
                                    class="text-xs text-left cursor-pointer hover:bg-dimGrey hover:opacity-50 mt-2 px-4"
                                  >
                                    <div
                                      class="flex flex-row justify-between items-start"
                                    >
                                      <div class="flex flex-row items-start">
                                        <app-circle-icon
                                          class="text-[10px]"
                                          [colorClass]="plant.online ? 'text-green-500' : 'text-red-500'"
                                        />

                                        <div class="pl-4 flex flex-col">
                                          <span>{{ plant.plantName }}</span>
                                          <span class="pt-1 leading-none text-[10px] text-gray-50 opacity-50">{{ plant.inverterType }}</span>
                                        </div>
                                      </div>
                                      @if (selectedPlant?.id === plant.id) {
                                        <app-check-circle-icon class="text-dark-accent-secondary text-[15px] mr-2" />
                                      }
                                    </div>
                                  </div>
                                </a>
                              }
                            </div>
                          }

                          @if (!isPrimaryPlant) {
                            <div
                              class="max-h-64 overflow-scroll w-full max-auto-scroll"
                            >
                              @for (
                                plant of plantList?.secondaryPlant;
                                track $index
                              ) {
                                <a (click)="navigateToDashboard(plant)">
                                  <div
                                    class="text-xs text-left cursor-pointer hover:bg-dimGrey hover:opacity-50 mt-2 px-4"
                                    (appClickableDirective)="selectPlant(plant.id)"
                                    (appClickableDirective)="addNewItem()"
                                  >
                                    <div
                                      class="flex flex-row justify-between items-start"
                                    >
                                      <div class="flex flex-row items-start">
                                        <app-circle-icon
                                          class="text-[10px]"
                                          [colorClass]="plant.online ? 'text-green-500' : 'text-red-500'"
                                        />

                                        <div class="pl-4 flex flex-col">
                                          <span>{{ plant.plantName }}</span>
                                          <span class="pt-1 leading-none text-[10px] text-gray-50 opacity-50">{{ plant.inverterType }}</span>
                                        </div>
                                      </div>

                                      @if (selectedPlant?.id === plant.id) {
                                        <app-check-circle-icon class="text-dark-accent-secondary text-[15px] mr-2" />
                                      }
                                    </div>
                                  </div>
                                </a>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  }

                  <div class="flex items-center">
                    <div class="flex items-center">
                      <img
                        matListItemIcon
                        src="assets/svg/{{ item.icon }}.svg"
                        alt="{{ item.icon }}"
                        [ngClass]="{
                          'svg-icon-active': rla.isActive || isActive
                        }"
                      />
                      <div>
                        <span
                          class="ml-1.5 sm:visible lg:hidden"
                          [ngClass]="{
                            'svg-icon-active': rla.isActive || isActive
                          }"
                        >
                          Dashboard</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            } @else {
              <div
                role="button"
                class="group relative flex items-center w-full py-4 pl-2 leading-tight transition-all md outline-none text-start hover:bg-gray-800 hover:rounded-r-2xl active:bg-blue-gray-50 active:bg-opacity-80 active:text-blue-gray-900 menu-item cursor-default"
                [routerLink]="item.route"
                routerLinkActive="selected-menu-item"
                #rla="routerLinkActive"
                [ngClass]="{ tooltip: true }"
                (appClickableDirective)="addNewItem()"
              >
                <div class="grid mr-4 place-items-center">
                  <div
                    [ngClass]="{ tooltip: true }"
                    class="sm:hidden lg:flex tooltip-content w-32 text-center py-2 dark:bg-dark-accent text-white text-xs p-1 rounded opacity-0 invisible transition-all absolute top-0 left-full ml-2 before:border-t-transparent before:border-b-transparent before:border-l-transparent before:border-r-dark-accent z-20"
                  >
                    <span class="tooltiptext">
                      {{ item.label | translate }}</span
                    >
                  </div>
                  <div class="flex items-center">
                    <div class="flex items-center">
                      <img
                        matListItemIcon
                        src="assets/svg/{{ item.icon }}.svg"
                        alt="{{ item.icon }}"
                        [ngClass]="{ 'svg-icon-active': rla.isActive }"
                      />
                    </div>
                    <div>
                      <span
                        class="lg:hidden ml-1.5"
                        [ngClass]="{ 'svg-icon-active': rla.isActive }"
                      >
                        {{ item.label | translate }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            }
          }
        }
      }

      @for (item of menuItems(); track $index) {
        @if (item.position === "Bottom" && item.enable) {
          <div
            role="button"
            class="group relative flex items-center w-full py-4 pl-2 leading-tight transition-all md outline-none text-start hover:bg-gray-800 hover:rounded-r-2xl active:bg-blue-gray-50 active:bg-opacity-80 active:text-blue-gray-900 menu-item cursor-default"
            routerLinkActive="selected-menu-item"
            #rla="routerLinkActive"
            [ngClass]="{ tooltip: true }"
          >
            <div class="grid mr-4 place-items-center">
              @if (item.route === "help") {
                <div
                  class="py-4 flex flex-col justify-start items-start menu-dropdown w-32 text-center bg-gray-800 text-white text-xs rounded-tr-lg rounded-br-lg gap-2 opacity-0 invisible transition-all absolute top-0 left-full before:border-t-transparent before:border-b-transparent before:border-l-transparent before:border-r-dark-accent z-20"
                >
                  <span
                    class="w-full pt-1 px-2 text-xs text-left"
                    routerLink="contact-us"
                    (appClickableDirective)="addNewItem()"
                    >Contact us</span
                  >
                  <span
                    class="w-full pt-1 px-2 text-xs text-left"
                    routerLink="faqs"
                    (appClickableDirective)="addNewItem()"
                    >FAQ</span
                  >
                  <span
                    class="w-full pt-1 px-2 text-xs text-left"
                    routerLink="video-guide"
                    (appClickableDirective)="addNewItem()"
                    >Video guide</span
                  >
                </div>
              } @else if (item.route === "setting") {
                <div
                  class="py-3 flex flex-col justify-start items-start menu-dropdown w-32 text-center bg-gray-800 text-white text-xs rounded-tr-lg rounded-br-lg gap-2 opacity-0 invisible transition-all absolute top-0 left-full before:border-t-transparent before:border-b-transparent before:border-l-transparent before:border-r-dark-accent z-20"
                >
                  <div>
                    <span
                      class="w-full px-2 text-xs text-left"
                      routerLink="change-password"
                      (appClickableDirective)="addNewItem()"
                      >{{ "setting" | translate }}</span
                    >
                  </div>
                </div>
              } @else {
                <div
                  (appClickableDirective)="addNewItem()"
                  class="tooltip-content w-32 text-center py-2 dark:bg-dark-accent text-white text-xs p-1 rounded opacity-0 invisible transition-all absolute top-0 left-full ml-2 before:border-t-transparent before:border-b-transparent before:border-l-transparent before:border-r-dark-accent z-20"
                >
                  <span class="tooltiptext"> {{ item.label | translate }}</span>
                </div>
              }
              <div class="flex items-center">
                <div class="flex items-center">
                  <img
                    matListItemIcon
                    src="assets/svg/{{ item.icon }}.svg"
                    alt="{{ item.icon }}"
                    [ngClass]="{ 'svg-icon-active': rla.isActive }"
                  />
                </div>
                <div
                  class="lg:hidden ml-1.5"
                  [ngClass]="{ 'svg-icon-active': rla.isActive }"
                >
                  @if (item.route == "help") {
                    <span>Help & Support</span>
                  } @else {
                    <span>Setting</span>
                  }
                </div>
              </div>
            </div>
          </div>
        }
      }
    </div>
  </div>
</div>
